import BaseApi from './BaseApi'

export default class RelationApi extends BaseApi {
  constructor (type = 0) {
    super('SubscriptionType', type)
  }

  /* async mySubscriptions (CusId: number|string) {
    const filter = { CusBlueId: CusId }
    const dt = <any> await this.filter(filter, { pagenumber: 1, pagesize: 200 })
    return dt.Data
  } */
  // TODO CHANGE THE ANY TYPE
  async getSubscriptions (code: any, config: any) {
    // {{Protocol}}://{{BaseUrl}}/{{AppUrl}}/{{Version}}/subscription/:Uci/list?pagesize=10&type=0
    const options = {
      url: `${process.env.VUE_APP_API_ENDPOINT}/${process.env.VUE_APP_API_VERSION}/subscriptiontype/BCO/${code}`,
      method: 'get'
      /* params: {
        type: 0,
        cusId: 4812,
        pagesize: 1000,
        pagenumber: -1
      } */
    }
    return await this.getApi(options)
  }

  async getAllSubscriptions () {
    // {{Protocol}}://{{BaseUrl}}/{{AppUrl}}/{{Version}}/subscription/:Uci/list?pagesize=10&type=0
    const options = {
      url: `${process.env.VUE_APP_API_ENDPOINT}/${process.env.VUE_APP_API_VERSION}/subscriptiontype/BCO/types`,
      method: 'get'
    }
    return await this.getApi(options)
  }

  async getFilteredSubscriptions (type: any, isCreg: any) {
    // {{Protocol}}://{{BaseUrl}}/{{AppUrl}}/{{Version}}/subscription/:Uci/list?pagesize=10&type=0
    const options = {
      url: `${process.env.VUE_APP_API_ENDPOINT}/${process.env.VUE_APP_API_VERSION}/subscriptiontype/BCO/types?type=${type}&include_creg=${isCreg}`,
      method: 'get'
    }
    return await this.getApi(options)
  }

  async addCustomFee (payload: any) {
    // {{Protocol}}://{{BaseUrl}}/{{AppUrl}}/{{Version}}/subscription/:Uci/list?pagesize=10&type=0
    const options = {
      url: `${process.env.VUE_APP_API_ENDPOINT}/${process.env.VUE_APP_API_VERSION}/subscriptiontype/BCO/custom`,
      method: 'post',
      data: payload
    }
    return await this.postApi(options)
  }
}
